import { Default, Detail,  List, Create } from "./views";

const Module = {
    name: "saltedgeproviders",
    defaultRoutePath: "/legalentities/saltedgeprovider",
    menuItemScope: "legalentities",
    menuItemName: "saltedgeproviders",
    routes: [
        {
            path: "/legalentities/saltedgeprovider",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
